export const DOMAIN = 'askAnalyst';
